// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gWwZ","clinicsSelect":"styles_clinicsSelect___VWQw"};